import React from 'react';

export function CwIcon(props: React.PropsWithChildren<unknown>): React.ReactElement {
    return (<span className={`cw-icon cw-icon-${props.children}`}  aria-hidden='true'/>);
}
